import React, { useState, useEffect } from "react";
import { Box, Button, Typography, ThemeProvider } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

import axios from "axios";
import UserAccess from "./UserAccess";
import { getUsersWithAccess } from "../../apiCalls/Apicalls";
import { CustomToolbar, theme } from "../../utilities/dataGridHelpers";

function UserData({
  handleModalOpen,
  userData,
  setUserData,
  areas,
  setAreas,
  selectedAreas,
  setSelectedAreas,
  data,
  filteredOptions,
  setFilteredOptions,
}) {
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [loading, setLoading] = useState(false);

  function fetchEndUsersWithAccess() {
    setLoading(true);
    axios
      .get(`${getUsersWithAccess}`)
      .then((response) => {
        const dataWithId = response.data.map((item, index) => ({
          ...item,
          id: item?.EmpId, // assuming EmpId is unique for each user
        }));
        setRows(dataWithId);
        setFilteredRows(dataWithId); // Initially display all rows
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching user data:", error);
      });
  }
  useEffect(() => {
    fetchEndUsersWithAccess();
  }, []);

  const handleRowClick = (rowData) => {
    const filteredData = rows.find((i) => i.id === rowData.id);
    setSelectedRow(filteredData);
    setOpenDrawer(true);
  };

  const columns = [
    {
      field: "EmpId",
      headerName: "Emp ID",
      resizable: false,
      sortable: false,
      flex: 50,
    },
    {
      field: "FullName",
      headerName: "Full Name",
      resizable: false,
      sortable: false,
      flex: 100,
    },
    {
      field: "Email",
      headerName: "Email",
      resizable: false,
      sortable: false,
      flex: 100,
    },
    {
      field: "SpaceName",
      headerName: "Department",
      resizable: false,
      sortable: false,
      flex: 100,
    },
    {
      field: "Contact",
      headerName: "Mobile Number",
      resizable: false,
      sortable: false,
      flex: 100,
    },
    {
      field: "access",
      headerName: "Access",
      resizable: false,
      sortable: false,
      flex: 50,
      renderCell: (params) => (
        <Button
          onClick={() => handleRowClick(params.row)}
          variant="text"
          size="small"
          sx={{
            fontSize: "0.78rem",
            fontWeight: 500,
            color: "var(--ax-blue)",
            textTransform: "none",
            px: 1,
          }}
        >
          View Access
        </Button>
      ),
    },
  ];
  return (
    <Box className="ax-page-grid">
      <ThemeProvider theme={theme}>
        <div
          className="ax-card ax-table-shell"
          style={{ padding: 0, paddingTop: 0 }}
        >
          <DataGrid
            sx={{
              minHeight: "400px",
              height: "calc(100vh - 230px)",
            }}
            disableColumnMenu
            loading={loading}
            rowHeight={52}
            getRowId={(row) => row.EmpId}
            rows={filteredRows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
            }}
            pageSizeOptions={[10, 25, 50]}
            disableRowSelectionOnClick
            slotProps={{
              toolbar: {
                showQuickFilter: true,
                quickFilterProps: { debounceMs: 500 },
                printOptions: { disableToolbarButton: true },
                csvOptions: { disableToolbarButton: true },
              },
            }}
            slots={{
              noRowsOverlay: () => (
                <Box
                  sx={{
                    display: "grid",
                    placeItems: "center",
                    height: "100%",
                  }}
                >
                  <Typography
                    sx={{ color: "var(--ax-ink-3)", fontSize: "0.86rem" }}
                  >
                    No users with access found
                  </Typography>
                </Box>
              ),
              toolbar: CustomToolbar,
            }}
          />
        </div>
      </ThemeProvider>
      <UserAccess
        open={openDrawer}
        onClose={() => {
          setSelectedRow({});
          setOpenDrawer(false);
        }}
        selectedRow={selectedRow}
        areas={areas}
        setAreas={setAreas}
        selectedAreas={selectedAreas}
        setSelectedAreas={setSelectedAreas}
        data={data}
        filteredOptions={filteredOptions}
        setFilteredOptions={setFilteredOptions}
        fetchEndUsersWithAccess={fetchEndUsersWithAccess}
      />
    </Box>
  );
}

export default UserData;
